<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatWidgetValue, formatPercent } from './widgetFormatters';

const props = defineProps({
  data: { type: Object, required: true },
});

const { t } = useI18n();

const rows = computed(() => {
  const items = props.data.items.map(item => ({ ...item }));
  if (props.data.others) {
    items.push({
      key: 'others',
      label: t('COMMERCIAL_WIDGETS.TABLE.OTHERS'),
      ...props.data.others,
    });
  }
  return items;
});
</script>

<template>
  <div class="flex-1 min-h-0 overflow-auto min-w-0">
    <p v-if="!rows.length" class="text-sm text-n-slate-10">
      {{ t('COMMERCIAL_WIDGETS.EMPTY_DATA') }}
    </p>
    <table v-else class="w-full text-sm">
      <thead>
        <tr class="sticky top-0 text-xs text-left bg-n-solid-1 text-n-slate-10">
          <th class="py-1 pr-2 font-normal">
            {{ t('COMMERCIAL_WIDGETS.TABLE.NAME') }}
          </th>
          <th class="py-1 pr-2 font-normal">
            {{ t('COMMERCIAL_WIDGETS.TABLE.VALUE') }}
          </th>
          <th class="py-1 font-normal">
            {{ t('COMMERCIAL_WIDGETS.TABLE.PERCENT') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.key" class="border-t border-n-weak">
          <td class="py-1 pr-2 break-words text-n-slate-12">
            {{ row.label }}
          </td>
          <td class="py-1 pr-2 whitespace-nowrap">
            {{ formatWidgetValue(row.value, data.format) }}
          </td>
          <td class="py-1 whitespace-nowrap">
            {{ formatPercent(row.percent) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
